var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs2, _path27, _defs3, _path28, _defs4, _path29, _path30, _path31, _path32, _path33, _defs5, _path34, _defs6, _path35, _path36, _path37, _defs7, _path38, _path39, _path40, _defs8, _polyline, _path41, _polyline2, _polyline3, _polyline4, _path42, _path43, _path44, _path45, _path46, _polygon5, _defs9, _defs10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRequests01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "163.9px",
    height: "140px",
    viewBox: "0 0 163.9 140",
    style: {
      enableBackground: "new 0 0 163.9 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#989898;}\n\t.st1{fill:#B4B4B4;}\n\t.st2{fill:#818181;}\n\t.st3{fill:#1A1A1A;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:url(#SVGID_2_);}\n\t.st6{fill:#010101;}\n\t.st7{opacity:0.8;}\n\t.st8{fill:#2AAAE2;}\n\t.st9{clip-path:url(#SVGID_4_);}\n\t.st10{opacity:0.3;}\n\t.st11{opacity:0.9;fill:#CCCCCC;}\n\t.st12{clip-path:url(#SVGID_6_);}\n\t.st13{clip-path:url(#SVGID_8_);}\n\t.st14{clip-path:url(#SVGID_10_);}\n\t.st15{clip-path:url(#SVGID_12_);}\n\t.st16{clip-path:url(#SVGID_14_);}\n\t.st17{clip-path:url(#SVGID_16_);}\n\t.st18{clip-path:url(#SVGID_18_);}\n\t.st19{opacity:0.8;fill:#2AAAE2;}\n\t.st20{opacity:0.8;fill:#67CAE5;}\n\t.st21{opacity:0.8;fill:url(#SVGID_19_);}\n\t.st22{opacity:0.8;fill:url(#SVGID_20_);}\n\t.st23{opacity:0.8;fill:#308DAF;}\n\t.st24{opacity:0.3;fill:#333333;}\n\t.st25{opacity:0.2;fill:#676767;}\n\t.st26{opacity:0.4;fill:#333333;}\n\t.st27{clip-path:url(#SVGID_22_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.9,133.6 5.5,89.5 0,92.7 81.9,140 163.9,92.7 158.4,89.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.9,39L0,86.3l5.5,3.2l76.4,44.1l76.4-44.1l5.5-3.2L81.9,39z M81.9,130L6.4,86.3l75.6-43.7l75.6,43.7 L81.9,130z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,92.7 0,86.3 81.9,133.6 81.9,140  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "81.9,133.6 163.9,86.3 163.9,92.7 81.9,140  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.4,86.3 81.9,42.7 157.5,86.3 155,87.9 81.9,45.4 8.3,87.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.9,45.4 8.3,87.9 81.9,130 155,87.9  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "36.3,70.7 36.3,86.5 81.9,112.8 81.9,97 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "81.9,97 127.5,70.7 127.5,86.5 81.9,112.8 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.3265,
    y1: 91.7486,
    x2: 81.8928,
    y2: 91.7486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101",
      stopOpacity: 0.3
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "36.3,70.7 36.3,86.5 81.9,112.8 81.9,97 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.8926,
    y1: 91.7475,
    x2: 127.4593,
    y2: 91.7475
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.3
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "81.9,97 127.5,70.7 127.5,86.5 81.9,112.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.5,84.6c0.3,0,0.6-0.1,0.8-0.2c0.6-0.3,0.9-1,0.9-1.8c0-0.7-0.2-1.4-0.6-2.1c-0.4-0.7-0.9-1.2-1.5-1.6 c-0.4-0.2-0.8-0.3-1.1-0.3c-0.3,0-0.6,0.1-0.8,0.2c-0.6,0.3-0.9,1-0.9,1.8c0,0.7,0.2,1.4,0.6,2.1c0.4,0.7,0.9,1.2,1.5,1.6 C45.7,84.5,46.1,84.6,46.5,84.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.1,100.4c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C35.7,100.2,34.9,100.4,34.1,100.4L34.1,100.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.2,105.7c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C44.8,105.5,44,105.7,43.2,105.7L43.2,105.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M52.3,110.9c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C53.9,110.8,53.2,110.9,52.3,110.9L52.3,110.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129.7,100.4c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C131.3,100.2,130.5,100.4,129.7,100.4L129.7,100.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M120.6,105.7c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C122.2,105.5,121.4,105.7,120.6,105.7L120.6,105.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.5,111c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C113,110.8,112.3,111,111.5,111L111.5,111z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.3,116.2c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C103.9,116,103.2,116.2,102.3,116.2L102.3,116.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.5,116.2c-0.8,0-1.6-0.2-2.2-0.5c-0.7-0.4-1.1-1-1.1-1.7c0-0.7,0.4-1.3,1.1-1.7c0.6-0.3,1.4-0.5,2.2-0.5 c0.8,0,1.6,0.2,2.2,0.5c0.7,0.4,1.1,1,1.1,1.7c0,0.7-0.4,1.3-1.1,1.7C63,116,62.3,116.2,61.5,116.2L61.5,116.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M55.6,89.9c0.3,0,0.6-0.1,0.8-0.2c0.6-0.3,0.9-1,0.9-1.8c0-0.7-0.2-1.4-0.6-2.1c-0.4-0.7-0.9-1.2-1.5-1.6 c-0.4-0.2-0.8-0.3-1.1-0.3c-0.3,0-0.6,0.1-0.8,0.2c-0.6,0.3-0.9,1-0.9,1.8c0,0.7,0.2,1.4,0.6,2.1c0.4,0.7,0.9,1.2,1.5,1.6 C54.8,89.8,55.2,89.9,55.6,89.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.7,95.1c0.3,0,0.6-0.1,0.8-0.2c0.6-0.3,0.9-1,0.9-1.8c0-0.7-0.2-1.4-0.6-2.1c-0.4-0.7-0.9-1.2-1.5-1.6 c-0.4-0.2-0.8-0.3-1.1-0.3c-0.3,0-0.6,0.1-0.8,0.2c-0.6,0.3-0.9,1-0.9,1.8c0,0.7,0.2,1.4,0.6,2.1c0.4,0.7,0.9,1.2,1.5,1.6 C63.9,95,64.3,95.1,64.7,95.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.8,100.4c0.3,0,0.6-0.1,0.8-0.2c0.6-0.3,0.9-1,0.9-1.8c0-0.7-0.2-1.4-0.6-2.1c-0.4-0.7-0.9-1.2-1.5-1.6 c-0.4-0.2-0.8-0.3-1.1-0.3c-0.3,0-0.6,0.1-0.8,0.2c-0.6,0.3-0.9,1-0.9,1.8c0,0.7,0.2,1.4,0.6,2.1c0.4,0.7,0.9,1.2,1.5,1.6 C73,100.3,73.4,100.4,73.8,100.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M90,100.4c-0.3,0-0.6-0.1-0.8-0.2c-0.6-0.3-0.9-1-0.9-1.8c0-0.7,0.2-1.4,0.6-2.1c0.4-0.7,0.9-1.2,1.5-1.6 c0.4-0.2,0.8-0.3,1.1-0.3c0.3,0,0.6,0.1,0.8,0.2c0.6,0.3,0.9,1,0.9,1.8c0,0.7-0.2,1.4-0.6,2.1c-0.4,0.7-0.9,1.2-1.5,1.6 C90.8,100.3,90.4,100.4,90,100.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M99.1,95.2c-0.3,0-0.6-0.1-0.8-0.2c-0.6-0.3-0.9-1-0.9-1.8c0-0.7,0.2-1.4,0.6-2.1c0.4-0.7,0.9-1.2,1.5-1.6 c0.4-0.2,0.8-0.3,1.1-0.3c0.3,0,0.6,0.1,0.8,0.2c0.6,0.3,0.9,1,0.9,1.8c0,0.7-0.2,1.4-0.6,2.1c-0.4,0.7-0.9,1.2-1.5,1.6 C99.9,95,99.5,95.2,99.1,95.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.2,89.9c-0.3,0-0.6-0.1-0.8-0.2c-0.6-0.3-0.9-1-0.9-1.8c0-0.7,0.2-1.4,0.6-2.1c0.4-0.7,0.9-1.2,1.5-1.6 c0.4-0.2,0.8-0.3,1.1-0.3c0.3,0,0.6,0.1,0.8,0.2c0.6,0.3,0.9,1,0.9,1.8c0,0.7-0.2,1.4-0.6,2.1c-0.4,0.7-0.9,1.2-1.5,1.6 C109,89.8,108.6,89.9,108.2,89.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M117.3,84.6c-0.3,0-0.6-0.1-0.8-0.2c-0.6-0.3-0.9-1-0.9-1.8c0-0.7,0.2-1.4,0.6-2.1c0.4-0.7,0.9-1.2,1.5-1.6 c0.4-0.2,0.8-0.3,1.1-0.3c0.3,0,0.6,0.1,0.8,0.2c0.6,0.3,0.9,1,0.9,1.8c0,0.7-0.2,1.4-0.6,2.1c-0.4,0.7-0.9,1.2-1.5,1.6 C118.1,84.5,117.7,84.6,117.3,84.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.1,98.4c0-0.5,0.2-1.1,0.5-1.7c0.3-0.5,0.7-1,1.2-1.3c0.5-0.3,0.9-0.3,1.2-0.1s0.5,0.6,0.5,1.1 c0,0.5-0.2,1.1-0.5,1.7c-0.3,0.5-0.7,1-1.2,1.3c-0.5,0.3-0.9,0.3-1.2,0.1S89.1,99,89.1,98.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M100.6,113c0.5-0.3,1.1-0.4,1.8-0.4s1.3,0.1,1.8,0.4s0.7,0.7,0.7,1c0,0.4-0.2,0.7-0.7,1 c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1C99.8,113.6,100.1,113.2,100.6,113z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M102.2,101.4c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6 C104.8,106.4,104.8,103,102.2,101.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M102.2,101.4c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6 C104.8,106.4,104.8,103,102.2,101.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 335,
    height: 512,
    xlinkHref: "F967C6B242E49B7B.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 90.3417 92.7401)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 331,
    height: 343,
    xlinkHref: "F967C6B242E49B79.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 92.6964 92.9311)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 461,
    height: 403,
    xlinkHref: "F967C6B242E49B7F.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 80.7316 85.6122)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 462,
    height: 402,
    xlinkHref: "F967C6B242E49B78.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 79.2042 87.6487)"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.2,93.2c0-0.5,0.2-1.1,0.5-1.7c0.3-0.5,0.7-1,1.2-1.3c0.5-0.3,0.9-0.3,1.2-0.1c0.3,0.2,0.5,0.6,0.5,1.1 c0,0.5-0.2,1.1-0.5,1.7c-0.3,0.5-0.7,1-1.2,1.3c-0.5,0.3-0.9,0.3-1.2,0.1S98.2,93.7,98.2,93.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109.7,107.7c0.5-0.3,1.1-0.4,1.8-0.4s1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1s-0.2,0.7-0.7,1 c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1S109.2,108,109.7,107.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107.3,87.9c0-0.5,0.2-1.1,0.5-1.7c0.3-0.5,0.7-1,1.2-1.3c0.5-0.3,0.9-0.3,1.2-0.1c0.3,0.2,0.5,0.6,0.5,1.1 c0,0.5-0.2,1.1-0.5,1.7c-0.3,0.5-0.7,1-1.2,1.3c-0.5,0.3-0.9,0.3-1.2,0.1S107.3,88.4,107.3,87.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M118.8,102.4c0.5-0.3,1.1-0.4,1.8-0.4c0.6,0,1.3,0.1,1.8,0.4s0.7,0.7,0.7,1c0,0.4-0.2,0.7-0.7,1 c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1C118.1,103.1,118.3,102.7,118.8,102.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M116.4,82.6c0-0.5,0.2-1.1,0.5-1.7c0.3-0.5,0.7-1,1.2-1.3c0.5-0.3,0.9-0.3,1.2-0.1s0.5,0.6,0.5,1.1 c0,0.5-0.2,1.1-0.5,1.7c-0.3,0.5-0.7,1-1.2,1.3c-0.5,0.3-0.9,0.3-1.2,0.1C116.6,83.6,116.4,83.2,116.4,82.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.9,97.2c0.5-0.3,1.1-0.4,1.8-0.4s1.3,0.1,1.8,0.4s0.7,0.7,0.7,1c0,0.4-0.2,0.7-0.7,1 c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1C127.2,97.8,127.4,97.5,127.9,97.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M111.3,96.2c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6C114,101.1,114,97.7,111.3,96.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M111.3,96.2c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6C114,101.1,114,97.7,111.3,96.2z "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 335,
    height: 513,
    xlinkHref: "F967C6B242E49B76.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 99.4425 87.4578)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 331,
    height: 343,
    xlinkHref: "F967C6B242E49B77.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 101.7973 87.6487)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 462,
    height: 403,
    xlinkHref: "F967C6B242E49B87.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 89.8325 80.3298)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 462,
    height: 402,
    xlinkHref: "F967C6B242E49B89.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 88.3051 82.3664)"
  }))))), /*#__PURE__*/React.createElement("g", null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M120.4,90.9c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6C123.1,95.8,123.1,92.5,120.4,90.9 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M120.4,90.9c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6 C123.1,95.8,123.1,92.5,120.4,90.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 335,
    height: 512,
    xlinkHref: "F967C6B242E49B8B.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 108.5434 82.2391)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 330,
    height: 344,
    xlinkHref: "BFFB7C3AB0A78D8.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 110.8982 82.43)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 462,
    height: 404,
    xlinkHref: "BFFB7C3AB0A78DF.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 98.9334 75.0475)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 404,
    xlinkHref: "BFFB7C3AB0A78D9.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 97.4696 77.0841)"
  }))))), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M129.5,85.7c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6C132.2,90.6,132.2,87.2,129.5,85.7 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M129.5,85.7c-2.6-1.5-10.3-6.1-10.3-6.1c-0.3-0.2-0.7-0.2-1.2,0.1c-0.5,0.3-0.9,0.7-1.2,1.3 c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.5,0.2,0.9,0.5,1.1c0,0,7.8,4.6,9.1,5.4c1.2,0.7,1.2,0.7,1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4,0.2,0.7,0.7,1c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1v-7.6 C132.2,90.6,132.2,87.2,129.5,85.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 335,
    height: 512,
    xlinkHref: "BFFB7C3AB0A78DB.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 117.6443 76.9568)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 330,
    height: 344,
    xlinkHref: "BFFB7C3AB0A78C6.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 120.0627 77.1477)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 402,
    xlinkHref: "BFFB7C3AB0A78C7.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 108.0343 69.8288)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 403,
    xlinkHref: "BFFB7C3AB0A78C8.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 106.5705 71.8654)"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.6,93.1c0-0.5-0.2-1.1-0.5-1.7c-0.3-0.5-0.7-1-1.2-1.3c-0.5-0.3-0.9-0.3-1.2-0.1s-0.5,0.6-0.5,1.1 c0,0.5,0.2,1.1,0.5,1.7c0.3,0.5,0.7,1,1.2,1.3c0.5,0.3,0.9,0.3,1.2,0.1C65.4,94.1,65.6,93.7,65.6,93.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.1,107.7c-0.5-0.3-1.1-0.4-1.8-0.4c-0.6,0-1.3,0.1-1.8,0.4c-0.5,0.3-0.7,0.7-0.7,1s0.2,0.7,0.7,1 c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1S54.6,108,54.1,107.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M56.5,87.9c0-0.5-0.2-1.1-0.5-1.7c-0.3-0.5-0.7-1-1.2-1.3c-0.5-0.3-0.9-0.3-1.2-0.1c-0.3,0.2-0.5,0.6-0.5,1.1 c0,0.5,0.2,1.1,0.5,1.7c0.3,0.5,0.7,1,1.2,1.3c0.5,0.3,0.9,0.3,1.2,0.1C56.3,88.8,56.5,88.4,56.5,87.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45,102.4c-0.5-0.3-1.1-0.4-1.8-0.4c-0.6,0-1.3,0.1-1.8,0.4s-0.7,0.7-0.7,1s0.2,0.7,0.7,1 c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1S45.5,102.7,45,102.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M52.5,96.2c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6C49.8,101.1,49.8,97.7,52.5,96.2 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M52.5,96.2c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6 C49.8,101.1,49.8,97.7,52.5,96.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 336,
    height: 512,
    xlinkHref: "BFFB7C3AB0A78CB.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 43.0553 87.4578)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 331,
    height: 343,
    xlinkHref: "BFFB7C3AB0A78C9.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 40.9551 87.6487)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 403,
    xlinkHref: "BFFB7C3AB0A78CF.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 44.5827 80.3298)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 462,
    height: 402,
    xlinkHref: "BFFB7C3AB0A78E3.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 46.0465 82.3664)"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M43.4,90.9c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6C40.7,95.8,40.7,92.5,43.4,90.9z "
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M43.4,90.9c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6 C40.7,95.8,40.7,92.5,43.4,90.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 334,
    height: 513,
    xlinkHref: "BFFB7C3AB0A78ED.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 33.9544 82.1755)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 330,
    height: 345,
    xlinkHref: "BFFB7C3AB0A78EF.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 31.8542 82.3664)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 404,
    xlinkHref: "BFFB7C3AB0A78E2.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 35.4818 75.0475)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 404,
    xlinkHref: "BFFB7C3AB0A78E1.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 36.9456 77.0841)"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.4,82.6c0-0.5-0.2-1.1-0.5-1.7c-0.3-0.5-0.7-1-1.2-1.3c-0.5-0.3-0.9-0.3-1.2-0.1S44,80.1,44,80.7 c0,0.5,0.2,1.1,0.5,1.7c0.3,0.5,0.7,1,1.2,1.3c0.5,0.3,0.9,0.3,1.2,0.1S47.4,83.2,47.4,82.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.9,97.2c-0.5-0.3-1.1-0.4-1.8-0.4c-0.6,0-1.3,0.1-1.8,0.4c-0.5,0.3-0.7,0.7-0.7,1c0,0.4,0.2,0.7,0.7,1 c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1C36.6,97.8,36.4,97.4,35.9,97.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M34.3,85.6c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6C31.6,90.6,31.6,87.2,34.3,85.6 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M34.3,85.6c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6 C31.6,90.6,31.6,87.2,34.3,85.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 336,
    height: 512,
    xlinkHref: "BFFB7C3AB0A78E5.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 24.7899 76.9568)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 330,
    height: 344,
    xlinkHref: "BFFB7C3AB0A78E7.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 22.7533 77.1477)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 462,
    height: 404,
    xlinkHref: "BFFB7C3AB0A78E0.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 26.3809 69.7652)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 403,
    xlinkHref: "BFFB7C3AB0A78DE.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 27.8447 71.8654)"
  }))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M74.7,98.4c0-0.5-0.2-1.1-0.5-1.7c-0.3-0.5-0.7-1-1.2-1.3c-0.5-0.3-0.9-0.3-1.2-0.1s-0.5,0.6-0.5,1.1 c0,0.5,0.2,1.1,0.5,1.7c0.3,0.5,0.7,1,1.2,1.3c0.5,0.3,0.9,0.3,1.2,0.1S74.7,98.9,74.7,98.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63.2,112.9c-0.5-0.3-1.1-0.4-1.8-0.4c-0.6,0-1.3,0.1-1.8,0.4c-0.5,0.3-0.7,0.7-0.7,1s0.2,0.7,0.7,1 c0.5,0.3,1.1,0.4,1.8,0.4c0.6,0,1.3-0.1,1.8-0.4c0.5-0.3,0.7-0.7,0.7-1C64,113.6,63.7,113.2,63.2,112.9z"
  })), /*#__PURE__*/React.createElement("g", null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M61.6,101.4c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6C59,106.4,59,103,61.6,101.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M61.6,101.4c2.6-1.5,10.3-6.1,10.3-6.1c0.3-0.2,0.7-0.2,1.2,0.1c0.5,0.3,0.9,0.7,1.2,1.3 c0.3,0.5,0.5,1.1,0.5,1.7c0,0.5-0.2,0.9-0.5,1.1c0,0-7.8,4.6-9.1,5.4c-1.2,0.7-1.2,0.7-1.2,2.5c0,2.1,0,6.6,0,6.6 c0,0.4-0.2,0.7-0.7,1c-0.5,0.3-1.1,0.4-1.8,0.4c-0.6,0-1.3-0.1-1.8-0.4c-0.5-0.3-0.7-0.7-0.7-1v-7.6C59,106.4,59,103,61.6,101.4z "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 335,
    height: 512,
    xlinkHref: "BFFB7C3AB0A791D.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 52.1562 92.7401)"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 330,
    height: 343,
    xlinkHref: "BFFB7C3AB0A7902.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 50.1196 92.9311)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 463,
    height: 404,
    xlinkHref: "BFFB7C3AB0A793D.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 53.6836 85.5485)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 462,
    height: 402,
    xlinkHref: "BFFB7C3AB0A793E.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 55.211 87.6487)"
  }))))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st19",
    points: "37,71.1 81.9,97 81.9,62 36.3,35.7 36.3,70.7 "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M78.9,60.3l3,1.7l2.9-1.7v0C83,61.4,80.7,61.3,78.9,60.3z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st19",
    points: "127.5,70.7 127.5,35.7 81.9,62 81.9,97 126.8,71.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.9681,
    y1: 78.8905,
    x2: 126.8907,
    y2: 53.5318
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5E5E5",
      stopOpacity: 0.4
    }
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st21",
    points: "127.5,70.7 127.5,35.7 81.9,62 81.9,97 126.8,71.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -626.1824,
    y1: 78.8903,
    x2: -582.2598,
    y2: 53.5316,
    gradientTransform: "matrix(-1 0 0 1 -545.3653 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5E5E5",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5676,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "36.3,70.7 36.3,35.7 81.9,62 81.9,97 37,71.1 "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M80,11.2L37,36.1l41.9,24.2c1.8,1.1,4.1,1.1,5.9,0l41.9-24.2L83.7,11.2C82.6,10.6,81.2,10.6,80,11.2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M81.9,0c-0.4,0-0.7,0.1-1.1,0.3l-43.4,25l-0.1,0.1c-0.3,0.2-0.6,0.5-0.8,0.8l38.4,22.2l6.8-3.9L81.9,0z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M81.9,0l0,44.4l6.8,3.9l38.4-22.2c-0.2-0.3-0.4-0.6-0.8-0.8l-13-7.5l-29-16.7L83,0.3C82.6,0.1,82.3,0,81.9,0z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M81.9,52.3L36.6,26.1c-0.2,0.3-0.3,0.7-0.3,1.1l0,43.5l44.5,25.7c0.3,0.2,0.7,0.3,1.1,0.3L81.9,52.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M127.5,27.2c0-0.4-0.1-0.7-0.3-1.1L81.9,52.3l0,44.4c0.4,0,0.7-0.1,1.1-0.3l44.5-25.7L127.5,27.2z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "88.7,48.3 81.9,44.4 75.1,48.3 81.9,52.3 "
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 976,
    height: 707,
    xlinkHref: "BFFB7C3AB0A793C.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 27.2719 18.2784)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 318,
    height: 318,
    xlinkHref: "BFFB7C3AB0A7903.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 71.7581 41.6352)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 976,
    height: 707,
    xlinkHref: "BFFB7C3AB0A7905.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 74.4947 18.2784)"
  }), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M127.5,35.7L84.8,60.4v0V50c-1.8,1-4,1-5.8,0v10.4L36.3,35.7l0,35l0.7,0.4L81.9,97l44.9-25.9l0.7-0.4 L127.5,35.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1775,
    height: 1290,
    xlinkHref: "BFFB7C3AB0A7906.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 25.4263 26.1064)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 343,
    height: 1005,
    xlinkHref: "BFFB7C3AB0A7904.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 70.9943 42.7171)"
  })))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M126.4,25.4l-13-7.5l-29-16.7L83,0.3C82.6,0.1,82.3,0,81.9,0c-0.4,0-0.7,0.1-1.1,0.3l-43.4,25l-0.1,0.1 c-0.3,0.2-0.6,0.5-0.8,0.8l38.4,22.2l6.8-3.9l6.8,3.9l38.4-22.2C127,25.8,126.7,25.6,126.4,25.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_24_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1729,
    height: 716,
    xlinkHref: "BFFB7C3AB0A790C.png",
    transform: "matrix(6.364251e-02 0 0 6.364251e-02 26.8901 -9.7243)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRequests01);
export default __webpack_public_path__ + "static/media/no_requests-01.e96db43f106c574063cd8dca2f418d54.svg";
export { ForwardRef as ReactComponent };